// extracted by mini-css-extract-plugin
export var assigneeBadge = "_kw-0";
export var assigneeDetails = "_kw-1";
export var assigneeInfo = "_kw-2";
export var dropdownContainer = "_kw-4";
export var dropdownImage = "_kw-5";
export var editAssigneeInfo = "_kw-3";
export var editAssigneeModalContainer = "_kw-6";
export var hidden = "_kw-8";
export var input = "_kw-7";